<template>
<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
  <div class="container-fluid">
    <router-link to="/" class="navbar-brand">MyAppMaps - Vue.js</router-link>

    <div class="collapse navbar-collapse d-flex flex-row-reverse bd-highlight" id="navbarNav">
      <ul class="navbar-nav">
        <router-link
            tag="li"
            to="/"
            exact
            class="nav-item active p-2 bd-highlight"
        >
            <a class="nav-link active" aria-current="page" href="#">Home</a>
        </router-link>

       <router-link
            tag="li"
            to="/search"
            class="nav-item active p-2 bd-highlight"
        >
            <a class="nav-link active" aria-current="page" href="#">Search</a>
        </router-link>

       <router-link
            tag="li"
            to="/about"
            class="nav-item active p-2 bd-highlight"
        >
            <a class="nav-link active" aria-current="page" href="#">About</a>
        </router-link>

      </ul>
    </div>
  </div>
</nav>
</template>

<script>
</script>

<style>
</style>
